import { Component, OnInit, ViewChild, Input,ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { map } from "rxjs/operators"; 


import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions
} from "ng-apexcharts";

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { EmployeeService } from '../../../../../services/employee.service';
import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';

//import multiselectdropdown
import { IDropdownSettings } from 'ng-multiselect-dropdown';

//import components
import { EmployeeCreateComponent } from '../../employee-create/employee-create.component';

// import * as html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { trim } from 'jquery';



export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
};

declare var $: any;

@Component({
  selector: 'app-employee-viewemployee',
  templateUrl: './employee-viewemployee.component.html',
  styleUrls: ['./employee-viewemployee.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class EmployeeViewemployeeComponent implements OnDestroy, OnInit {
  getPhotoBase64;

  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  //dropdownSettings:IDropdownSettings;

  //common data
  data: any;

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  viewEmployeeModal: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  ordinary_data: BsModalRef;

  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  emp: any;
  training: any;
  leftside: any;
  rightside: any;
  allrec_round: any;
  chart_left: any;
  chart_right: any;
  chart_center: any;
  chartdata: any;

  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');

  id: number;
  modalTitle: any;


  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  generalsFormMsg: any;
  rolepermission: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  dtOptions: DataTables.Settings = {};

  @ViewChild("chart") chart: ChartComponent;

  constructor(
    private formBuilder: FormBuilder,

    private servicingService: ServicingService,
    private modalService: BsModalService,
    private employeeService: EmployeeService,

    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private bsModalRef: BsModalRef,


  ) { }

  
  ngOnInit() {
    this.data = [];

    this.getData();
    

    this.dtOptions = {
      paging: false,
      processing: true
    };
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  getData() {

    this.employeeService.getList()
      .subscribe(
        (res) => {
          // console.log('test');
          this.lang = this.employeeService.listLang(res);
          this.records = res.data.all_record;
          this.modalTitle = this.lang.employees;

        }
      );

  }
}
